<div
  class="sign-in"
  id="signInContainer"
  *ngIf="(loggedIn$ | async) === false"
  [ngClass]="{ 'is-zoomed': isZoomed }"
>
  <div class="rectangle-parent" [ngClass]="{ 'is-zoomed': isZoomed }">
    <img
      class="vector-icon"
      alt="login-logo"
      src="assets/img/EY_Logo_Beam_STFWC_Horizontal_Large_RGB_White_Yellow_EN.png"
    />

    <div class="text-container">
      <div class="header">Welcome to CIT Agent</div>

      <div class="label-container">
        <div class="text">Please sign in with SSO below (required)</div>
      </div>
    </div>

    <button motif-button class="button yellow" (click)="onClickLogin()">
      I am an EY employee
    </button>
  </div>
  <!--  -->
</div>
